import React from "react";
import { Button } from "@blueprintjs/core";
import api from "../../common/lib/api";
import { removeSession } from "../../helpers/session";
import PairDeviceButton from "./PairDeviceButton";

export default function Session({ session, sessionData }) {
  return (
    <div style={{ float: "right" }}>
      <Button
        onClick={async () => {
          logout(session);
          window.location = "/web";
        }}
      >
        Logout
      </Button>
      <PairDeviceButton token={sessionData.token} />
    </div>
  );
}

function logout(session) {
  api.post("/logout");
  removeSession(session);
  api.clearLogin();
}
